"use strict";

exports.__esModule = true;
exports.initialLogicalOperator = exports.logicalOperator = exports.mediaFeature = exports.mediaTypes = exports.defaultBreakpoints = exports.screenOrientation = void 0;
var screenOrientation = {
  landscape: 'landscape',
  portrait: 'portrait'
};
exports.screenOrientation = screenOrientation;
var defaultBreakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
exports.defaultBreakpoints = defaultBreakpoints;
var mediaTypes = {
  all: 'all',
  aural: 'aural',
  braille: 'braille',
  handheld: 'handheld',
  print: 'print',
  projection: 'projection',
  screen: 'screen',
  tty: 'tty',
  tv: 'tv',
  embossed: 'embossed'
};
exports.mediaTypes = mediaTypes;
var mediaFeature = {
  width: 'width',
  minWidth: 'min-width',
  maxWidth: 'max-width',
  height: 'height',
  minHeight: 'min-height',
  maxHeight: 'max-height',
  deviceWidth: 'device-width',
  minDeviceWidth: 'min-device-width',
  maxDeviceWidth: 'max-device-width',
  deviceHeight: 'device-height',
  minDeviceHeight: 'min-device-height',
  maxDeviceHeight: 'max-device-height',
  aspectRatio: 'aspect-ratio',
  minAspectRatio: 'min-aspect-ratio',
  maxAspectRatio: 'max-aspect-ratio',
  deviceAspectRatio: 'device-aspect-ratio',
  minDeviceAspectRatio: 'min-device-aspect-ratio',
  maxDeviceAspectRatio: 'max-device-aspect-ratio',
  color: 'color',
  minColor: 'min-color',
  maxColor: 'max-color',
  colorIndex: 'color-index',
  minColorIndex: 'min-color-index',
  maxColorIndex: 'max-color-index',
  monochrome: 'monochrome',
  minMonochrome: 'min-monochrome',
  maxMonochrome: 'max-monochrome',
  resolution: 'resolution',
  minResolution: 'min-resolution',
  maxResolution: 'max-resolution',
  scan: 'scan',
  grid: 'grid'
};
exports.mediaFeature = mediaFeature;
var logicalOperator = {
  and: 'and',
  or: ','
};
exports.logicalOperator = logicalOperator;
var initialLogicalOperator = {
  not: 'not',
  only: 'only'
};
exports.initialLogicalOperator = initialLogicalOperator;